// import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type.ts';
import { statusTransitionDetailCardActionsGenerator } from '@/modules/FileDetail/data/statusTransitionList/statusTransitionDetailCardActionsGenerator';
import statusTransitionDetailCardDefaultDataGenerator from '@/modules/FileDetail/data/statusTransitionList/statusTransitionDetailCardDefaultDataGenerator';
import { statusTransitionQueryResponseType } from '@/modules/FileDetail/queries/statusTransition/statusTransitionQuery.type';
// import { InfiniteData } from '@tanstack/react-query';

export const statusTransitionQueryGenerator = (
  data: statusTransitionQueryResponseType[],
) => {
  const items = data.map((item) => ({
    // ...page,
    // results: page?.map((item) => ({
    ...item,
    detailCardItems: statusTransitionDetailCardDefaultDataGenerator(item),
    action: statusTransitionDetailCardActionsGenerator(item?.description),
  }));
  const result = [
    ...items,
    // pages,
  ];

  return result;
};
